export enum StatePrescriptionIdentification {
    SemReceita = 1,
    ReceitaPendente = 2,
    SolicitarLente = 3,
    AguardandoLente = 4,
    AguardandoMontagemInterna = 5,
    AguardandoConferencia = 6,
    Ok = 7,
    AguardandoMontagemExterna = 8,
}